export type Shopper = { vendorId: string; sessionId: string | null; isGuest: boolean; accessToken?: string | null }

// The backend only accepts the Customer header as a guest cart session; a
// logged-in shopper is identified by their access token.
export const shopperHeaders = ({ vendorId, sessionId, isGuest, accessToken }: Shopper) => ({
  Vendor: vendorId,
  Customer: sessionId,
  CustomerType: isGuest ? 'guest' : 'registered',
  ...(!isGuest && accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
}) as any
